import Image from "next/image";
import Link from "next/link";
import React from "react";
import { s3Static } from "utils/constants";
import { ELECTRICIAN_HUB, HANDYMAN_PRICE_PAGE, PLUMBER_HUB, jobPagePath } from "data/handyman-job-pages";

// Shared by the handyman and plumber hubs. Every card has an H3 and a link:
// two cards used to have neither, so they could not pass any relevance to a
// page. Availability wording must match the 08:00-22:00 openingHours.
const handymanServicesData = [
  {
    title: "Plumbing Repairs & Installations",
    desc: [
      "Leak repairs, drain unclogging, and tap, toilet bowl and shower set replacements",
      "Same-day slots for urgent plumbing problems such as burst pipes and choked toilets",
    ],
    href: PLUMBER_HUB,
    linkLabel: "Plumber services",
    image: "handyman/handyman-plumber-fixing-kitchen-pipes.jpg",
  },
  {
    title: "Electrical Troubleshooting & Installations",
    desc: [
      "Power socket and switch repairs, power trip troubleshooting, LED lighting, ceiling fans and wiring fixes",
      "Carried out by licensed electricians across Singapore",
    ],
    href: ELECTRICIAN_HUB,
    linkLabel: "Electrician services",
    image: "handyman/electrician-installing-lights.jpg",
  },
  {
    title: "Door Locks, Handles & Windows",
    desc: [
      "Door and gate lock replacement, door handle and knob replacement, and window lock and hinge repair",
      "A common first job after moving into a resale flat",
    ],
    href: jobPagePath("door-lock-replacement"),
    linkLabel: "Door lock replacement",
    image: "handyman/chinese-handyman-with-hammer.jpg",
  },
  {
    title: "TV Mounting & Wall Installations",
    desc: [
      "TV bracket installation, mirrors, wall shelves, artwork and curtain rails",
      "Fixings chosen to suit HDB, BTO and condo walls",
    ],
    href: jobPagePath("tv-mounting"),
    linkLabel: "TV wall mounting",
    image: "handyman/handyman-install-tv.jpg",
  },
  {
    title: "Painting & Wall Repair",
    desc: [
      "Interior painting for a single room or a whole HDB flat, at fixed prices by flat size",
      "Wall touch-ups and repainting before you move in or hand over a rental",
    ],
    href: HANDYMAN_PRICE_PAGE + "#prices-painting",
    linkLabel: "Painting prices",
    image: "handyman/handyman-painter-painting-wall.jfif",
  },
  {
    title: "Furniture Assembly & Repair",
    desc: [
      "Bed frame assembly, wall-mounted shelves and cabinet or cupboard hinge replacement",
      "Soft-close hydraulic hinges fitted to sagging cupboard doors",
    ],
    href: jobPagePath("furniture-assembly"),
    linkLabel: "Furniture assembly",
    image: "handyman/handyman-assembles-bed.jfif",
  },
];

export const HandymanServices = () => {
  return (
    <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 py-4 md:py-8">
      {handymanServicesData.map(({ title, desc, href, linkLabel, image }) => (
        <div
          key={title}
          className="flex flex-col bg-white rounded-3xl shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden"
        >
          {/* Was h-72 on mobile: six of these added ~1,700px of scrolling. */}
          <div className="h-44 sm:h-64 relative">
            <Image
              src={s3Static + image}
              fill
              style={{ objectFit: "cover", objectPosition: "center" }}
              placeholder="blur"
              blurDataURL={s3Static + "placeholder.png"}
              alt={title}
              sizes="(max-width: 768px) 100vw, 50vw"
            />
          </div>
          <div className="flex flex-col flex-1 px-4 py-4">
            <h3 className="text-lg font-bold text-gray-900 mb-2">{title}</h3>
            <ul className="leading-relaxed space-y-1.5 list-disc pl-5 text-sm text-gray-600 flex-1">
              {desc.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <Link
              href={href}
              prefetch={false}
              className="mt-4 self-start inline-flex items-center min-h-11 px-5 rounded-full bg-linear-to-tr from-orange-600 to-amber-400 text-white text-sm font-bold hover:opacity-90 transition"
            >
              {linkLabel} &rarr;
            </Link>
          </div>
        </div>
      ))}
    </div>
  );
};
